const config = {
	development: {
	  apiUrl: 'http://localhost:3001',
	  apiEndpoint: '/api/query',
	  cors: {
		origin: ['http://localhost:3000'],
		credentials: true
	  }
	},
	production: {
	  // Update to use the Lambda Function URL
	  apiUrl: 'https://rrl7lhx2pgqnofhl4yd4kfmc7i0wrdwo.lambda-url.eu-central-1.on.aws',
	  apiEndpoint: '', // Lambda Function URL doesn't need additional endpoint
	  cors: {
		origin: ['https://www.digital-horizon.cz', 'https://main.d2kt1x1qk0xajt.amplifyapp.com'],
		credentials: true
	  }
	}
  };
  
  export const getConfig = () => {
	const environment = process.env.REACT_APP_ENV || 'development';
	const useLocal = process.env.REACT_APP_USE_LOCAL === 'true';
   
	if (useLocal) {
	  return config.development;
	}
   
	return config.production;
  };